<template>
  <div class="subview payment">
    <h2 class="h3">Montant à payer</h2>
    <div class="payment-wrapper recap">
      <ul class="recap-list">
        <li
          v-for="place in order.tickets"
          :key="`place-${place.id}`"
          class="recap-item"
        >
          <span>{{ getTitle(place) }}</span>
          <span>{{ place.price.value }} €</span>
        </li>
      </ul>

      <p class="recap-total">
        <span>Total</span>
        <span>{{ total }} €</span>
      </p>
    </div>

    <div class="payment-wrapper form">
      <div class="checkboxes">
        <div class="checkbox">
          <input
            :checked="infos.policy.privacy"
            @change="onChange($event, 'privacy')"
            id="selling-policy"
            type="checkbox"
            value="selling-policy"
            class="u-visually-hidden"
          >
          <label for="selling-policy">J’ai lu et j’accepte les conditions de vente</label>
        </div>
        <div class="checkbox">
          <input
            :checked="infos.policy.age"
            id="age-policy"
            type="checkbox"
            value="age-policy"
            class="u-visually-hidden"
            @change="onChange($event, 'age')"
          >
          <label for="age-policy">Je déclare avoir plus de 16 ans</label>
        </div>
      </div>
    </div>

    <p
      v-if="error"
      class="error"
    >
      {{ error }}
    </p>

    <!-- :nextLabel="'Payer'" -->
    <pagination
      :back="true"
      :nextDisable="displayNext"
      :nextLabel="'Lancer paiement'"
      @prev="onPrev"
      @next="onNext"
    />
  </div>
</template>

<script>
// import Selection from '@/components/components/Selection.vue';
// import Field from '@/components/modules/Field.vue';
import Pagination from '@/components/partials/Pagination.vue';
// Data
import basket from '@/data/static/basket.json';

export default {
  components: {
    // Selection,
    // Field,
    Pagination
  },
  data() {
    return {
      methods: [...basket.payment.methods]
    };
  },
  beforeMount() {
    this.$store.commit('basket/setError', null);
  },
  computed: {
    infos() {
      return this.$store.state.basket.infos;
    },
    error() {
      return this.$store.state.basket.error;
    },
    order() {
      if (!this.$store.state.basket.datas.order) {
        return {};
      }

      return this.$store.state.basket.datas.order;
    },
    total() {
      let total = 0;

      if (!this.$store.state.basket.datas.order) {
        return total;
      }

      for (let i = 0; i < this.$store.state.basket.datas.order.tickets.length; i++) {
        const ticket = this.$store.state.basket.datas.order.tickets[i];
        total += ticket.price.value;
      }

      return total;
    },
    displayNext() {
      const { infos } = this.$store.state.basket;
      return !infos.policy.privacy || !infos.policy.age;

      /* eslint-disable */
      let valid = !infos.method || !infos.policy.privacy || !infos.policy.age;

      if (infos.method && infos.method === 'credit') {
        this.methods[1].fields.map(field => {
          if (!infos.credit[field.name] || infos.credit[field.name].length === 0) {
            valid = true;
          }

          return field;
        });
      }

      return valid;
    }
  },
  methods: {
    getTitle(place) {
      if (place.title) {
        return `${place.title} - ${place.category}`;
      }

      return place.category
    },
    onChange($event, type) {
      const { currentTarget } = $event;
      this.$store.commit('basket/updatePolicy', {
        value: currentTarget.checked,
        type
      });
    },
    onCheckMethod($event) {
      this.$store.commit('basket/updateInfo', {
        value: $event,
        type: 'method'
      });
    },
    onCreditInput($event, type) {
      this.$store.commit('basket/updateCredit', {
        value: $event,
        type
      });
    },
    onPrev() {
      this.$router.push({ name: 'BasketInformations' });
    },
    async onNext() {
      this.$ga.event('webapp', 'checkout', this.$store.state.basket.datas.order.label);

      // eslint-disable-next-line
      const confirm = await this.$store.dispatch('basket/pay');
      // const confirm = await this.$store.dispatch('basket/confirmOrder');
    }
  }
};
</script>

<style lang="scss" scoped>
.payment {
  .h3 {
    @include padding(null null 3px);

    &:not(:first-child) {
      @include margin(40px null null);
    }
  }

  &-wrapper {
    @include margin(24px null null);
    @include padding(38px null null);
    border-top: 1px solid $grey-light-alternate;

    &.recap {
      @include padding(null 16px);
    }
  }

  .recap {
    &-item {
      @include font('secondary', 'regular');
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: rem(20px);
      line-height: (24 / 20);

      + .recap-item {
        @include margin(18px null null);
      }
    }

    &-total {
      @include font('secondary', 'bold');
      @include margin(34px null null);
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: rem(20px);
      line-height: (24 / 20);
    }
  }

  .methods {
    &-method {
      position: relative;

      + .methods-method {
        @include margin(16px null null);
      }

      input {
        &:checked + label::after {
          transform: scale(1);
          opacity: 1;
        }
      }

      label {
        @include padding(null null null 32px);
        @include font('secondary', 'regular');
        position: relative;
        font-size: rem(18px);
        line-height: (21 / 18);

        &::before {
          @include position(absolute, 8px null null 0);
          @include size(16px);
          content: '';
          border-radius: 50%;
          border: 2px solid $grey-light-alternate;
        }

        &::after {
          @include position(absolute, 12px null null 4px);
          @include size(8px);
          content: '';
          transform: scale(.4);
          transition: transform .3s $ease-out-quart, opacity .3s $ease-out-quart;
          border-radius: 50%;
          opacity: 0;
          background-color: $primary;
        }

        img {
          @include margin(null null null 8px);
          @include size(50px, 35px);
          vertical-align: middle;
        }

        .label-text {
          min-width: 120px
        }
      }

      &-form {
        @include padding(32px null null 54px);
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        position: relative;
        z-index: 1;

        .field {
          width: 100%;

          &:not(:first-child) {
            @include margin(8px null null);
          }
        }

        .selection {
          @include margin(8px null null);
          width: calc(50% - 8px);
        }
      }
    }
  }

  .checkboxes {
    // @include margin(30px null null);
    @include padding(null null 58px);

    .checkbox {
      &:not(:first-child) {
        @include margin(8px null null);
      }

      input {
        &:checked + label::after {
          transform: scale(1);
          opacity: 1;
        }
      }

      label {
        @include padding(5px null 5px 24px);
        @include font('secondary', 'regular');
        display: block;
        position: relative;
        font-size: rem(14px);
        line-height: (17 / 14);

        &::before {
          @include position(absolute, 4px null null 0);
          @include size(16px);
          content: '';
          border: 2px solid rgba($white, .4);
        }

        &::after {
          @include position(absolute, 8px null null 4px);
          @include size(8px);
          content: '';
          transform: scale(.4);
          transition: transform .3s $ease-out-quart, opacity .3s $ease-out-quart;
          opacity: 0;
          background-color: $primary;
        }
      }
    }
  }

  .error {
    @include margin(-30px null null);
    color: $primary;
    font-size: rem(14px);
    letter-spacing: .5px;
  }
}
</style>
